<template>
  <div class="nvx-scrollable-scaffold">
    <div ref="scrollable" class="nvx-scrollable-scaffold-content" :style="{ paddingBottom: scrollPaddingBottom }">
      <slot name="content" />
    </div>
    <div ref="sticky" class="nvx-scrollable-scaffold-buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NvxScrollableScaffold',

  props: {
    extraBottomSpace: {
      type: Number,
      default: 12,
    },
  },

  data() {
    return {
      stickyHeight: 0,
      resizeObserver: null,
    }
  },

  computed: {
    scrollPaddingBottom() {
      return `${this.stickyHeight + this.extraBottomSpace}px`
    },
  },

  mounted() {
    this.updateStickyHeight()

    if (this.$refs.sticky && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateStickyHeight()
      })
      this.resizeObserver.observe(this.$refs.sticky)
    }

    window.addEventListener('resize', this.updateStickyHeight)
  },

  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    window.removeEventListener('resize', this.updateStickyHeight)
  },

  methods: {
    updateStickyHeight() {
      const el = this.$refs.sticky
      if (!el) return
      this.stickyHeight = el.offsetHeight || 0
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/assets/scss/style.scss';
@use '@/assets/scss/appmenus/native.scss';

.nvx-scrollable-scaffold {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.nvx-scrollable-scaffold-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 1.5rem;
  -webkit-overflow-scrolling: touch;
}

.nvx-app-container .nvx-scrollable-scaffold-buttons {
  :deep(.nvx-button) {
    margin-top: 0;
  }
}

.nvx-scrollable-scaffold-buttons {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  gap: 16px;
  padding: 32px 1.5rem 8px 1.5rem;

  background-image: linear-gradient(
    to bottom,
    rgba(var(--color-background-rgb), 0) 0%,
    rgba(var(--color-background-rgb), 0.7) 10%,
    rgba(var(--color-background-rgb), 0.85) 25%,
    rgba(var(--color-background-rgb), 0.95) 45%,
    rgba(var(--color-background-rgb), 1) 70%
  );
}

@media (prefers-color-scheme: dark) {
  .nvx-scrollable-scaffold-buttons {
    background-image: linear-gradient(
      to bottom,
      rgba(var(--color-background-dark-rgb), 0) 0%,
      rgba(var(--color-background-dark-rgb), 0.7) 10%,
      rgba(var(--color-background-dark-rgb), 0.85) 25%,
      rgba(var(--color-background-dark-rgb), 0.95) 45%,
      rgba(var(--color-background-dark-rgb), 1) 70%
    );
  }
}
</style>
